<template>
  <FormGroup
    :inputId="idCalc"
    :errors="errorsCalc"
    :successes="successes"
    :description="description"
    class="form-check"
    label-class="form-check-label"
  >
    <slot name="label">
      <label :for="idCalc" v-if="label" :class="labelType" v-html="label" />
    </slot>
    <template #checkbox>
      <input
        type="checkbox"
        :data-test="testId"
        :id="idCalc"
        @change="emitChange"
        :class="['form-check-input', inputType]"
        :checked="value || modelValue"
        :disabled="disabled"
        :name="name"
        :tabindex="tabindex"
      />
    </template>
  </FormGroup>
</template>

<script>
import { computed } from "vue";
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormCheckbox",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  emits: ["change", "input", "update:modelValue"],
  props: {
    name: String,
    modelValue: Boolean,
    value: Boolean,
    variant: String,
    testId: String,
  },
  setup(props, { emit }) {
    const labelTypeList = {
      default: "",
      dark: "dark-checkbox-label",
    };
    const labelType = computed(() =>
      !labelTypeList[props.variant] ? labelTypeList.default : labelTypeList[props.variant]
    );
    const inputTypeList = {
      default: "",
      dark: "dark-checkbox-input",
    };
    const inputType = computed(() =>
      !inputTypeList[props.variant] ? inputTypeList.default : inputTypeList[props.variant]
    );

    const emitChange = (e) => {
      const checked = e.target.checked;
      emit("input", checked);
      emit("change", checked);
      emit("update:modelValue", checked);
    };
    return { emitChange, labelType, inputType };
  },
};
</script>
